/* ==========================================================================
   tu-adv-sales-page.js
   Steuert den Varianten-Waehler im Hero der Landingpage-Section.
   Alles ist auf die Section-ID gescoped, damit mehrere Instanzen pro Seite
   nebeneinander laufen koennen, ohne sich gegenseitig zu ueberschreiben.
   ========================================================================== */
(function () {
  'use strict';

  function euro(el) {
    return el ? el.textContent.trim() : '';
  }

  function initSection(root) {
    if (!root || root.dataset.tuAspInit === 'true') return;
    root.dataset.tuAspInit = 'true';

    var tiers = root.querySelectorAll('[data-tu-tier]');
    if (!tiers.length) return;

    var variantInput = root.querySelector('[data-tu-variant-input]');
    var ctaLabel = root.querySelector('[data-tu-cta-label]');
    var ctaLink = root.querySelector('[data-tu-cta-link]');
    var ctaTemplate = root.getAttribute('data-tu-cta-template') || '';
    var mobPrice = root.querySelector('[data-tu-mob-price]');
    var mobCompare = root.querySelector('[data-tu-mob-compare]');
    var priceTag = root.querySelector('[data-tu-pricetag-value]');
    var priceTagFollows = root.getAttribute('data-tu-pricetag-follows') === 'true';

    function apply(tier) {
      var i;
      for (i = 0; i < tiers.length; i++) {
        tiers[i].setAttribute('aria-pressed', tiers[i] === tier ? 'true' : 'false');
      }

      var price = euro(tier.querySelector('[data-tu-tier-price]'));
      var compare = euro(tier.querySelector('[data-tu-tier-compare]'));
      var name = tier.getAttribute('data-tu-tier-name') || '';
      var variantId = tier.getAttribute('data-tu-variant') || '';
      var url = tier.getAttribute('data-tu-url') || '';

      if (variantInput && variantId) variantInput.value = variantId;
      if (ctaLink && url) ctaLink.setAttribute('href', url);

      if (ctaLabel && ctaTemplate) {
        ctaLabel.textContent = ctaTemplate
          .replace('[name]', name)
          .replace('[price]', price);
      }

      if (mobPrice) mobPrice.textContent = price;
      if (mobCompare) mobCompare.textContent = compare;
      if (priceTag && priceTagFollows) priceTag.textContent = price;
    }

    for (var i = 0; i < tiers.length; i++) {
      (function (tier) {
        tier.addEventListener('click', function () {
          apply(tier);
        });
      })(tiers[i]);
    }

    var preselected = root.querySelector('[data-tu-tier][aria-pressed="true"]');
    apply(preselected || tiers[0]);
  }

  function initAll(scope) {
    var roots = (scope || document).querySelectorAll('[data-tu-asp-root]');
    for (var i = 0; i < roots.length; i++) initSection(roots[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll(document);
    });
  } else {
    initAll(document);
  }

  /* Shopify Theme-Editor: neu laden, wenn die Section neu gerendert wird */
  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
  document.addEventListener('shopify:block:select', function (event) {
    var tier = event.target.closest ? event.target.closest('[data-tu-tier]') : null;
    if (tier) tier.click();
  });
})();